/** Bảng chọn chính sách giá: Rẻ / Cân bằng / Đắt. */
import type { ChinhSachGiaChon } from '../../core/types.js';
import type { GameController } from '../game-controller.js';
import { styleNutChinh, styleNutPhu, stylePanel, useCapNhat } from '../dung-chung.js';

const CAC_CHINH_SACH: { ma: ChinhSachGiaChon; ten: string; moTa: string }[] = [
  { ma: 're', ten: 'Rẻ', moTa: 'Đông khách, lãi mỗi món thấp, danh tiếng tăng nhanh' },
  { ma: 'canBang', ten: 'Cân bằng', moTa: 'Mặc định, ổn định' },
  { ma: 'dat', ten: 'Đắt', moTa: 'Lãi mỗi món cao, ít khách, danh tiếng giảm' },
];

export function PanelChinhSach(props: { controller: GameController }) {
  const { controller } = props;
  useCapNhat(controller);
  const hienTai = controller.state.chinhSach;

  return (
    <div style={stylePanel}>
      <h3 style={{ margin: '0 0 8px' }}>💲 Chính sách giá</h3>
      {CAC_CHINH_SACH.map((cs) => (
        <button
          key={cs.ma}
          onClick={() => controller.chonChinhSach(cs.ma)}
          title={cs.moTa}
          style={`${hienTai === cs.ma ? styleNutChinh : styleNutPhu} display: block; width: 100%; margin-bottom: 6px; text-align: left;`}
        >
          {hienTai === cs.ma ? '● ' : '○ '}
          {cs.ten}
          <div style={{ fontWeight: 400, fontSize: '12px', opacity: 0.85 }}>{cs.moTa}</div>
        </button>
      ))}
    </div>
  );
}
